'use client';

import tokens from '@vaad1st/shared.design-tokens/json/variables.json';
import { useEffect, useState } from 'react';

export enum ScreenSize {
  Mobile = 'MOBILE',
  Tablet = 'TABLET',
  Desktop = 'DESKTOP',
}

// A hook for ScrenSize
// Gets the inneerWidth of the current window and returns the matching Media Breakpoint
export const useMediaBreakpoint = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>();

  const breakpointMobile = tokens.breakpoint_max_screen_sm.value; // 767
  const breakpointTablet = tokens.breakpoint_max_screen_lg.value; // 1279

  useEffect(() => {
    const setMediaBreakpoint = (e: any) => {
      const {
        target: { innerWidth: width },
      } = e;

      width <= breakpointMobile
        ? setScreenSize(ScreenSize.Mobile)
        : width <= breakpointTablet
          ? setScreenSize(ScreenSize.Tablet)
          : setScreenSize(ScreenSize.Desktop);
    };

    window.addEventListener('resize', setMediaBreakpoint);

    setMediaBreakpoint({ target: window });

    return () => {
      window.removeEventListener('resize', setMediaBreakpoint);
    };
  });

  return screenSize;
};
